import React, { useCallback, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { makeStyles, Theme } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import FitnessCenterIcon from "@material-ui/icons/FitnessCenter";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import AssignmentIcon from "@material-ui/icons/Assignment";
import ThreeSixtyIcon from "@material-ui/icons/ThreeSixty";
import RepeatIcon from "@material-ui/icons/Repeat";
import Button from "@material-ui/core/Button";
import RemoveCircleIcon from "@material-ui/icons/RemoveCircle";
import { useHistory } from "react-router";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { useSelector, useDispatch } from "react-redux";
import DirectionsRunIcon from "@material-ui/icons/DirectionsRun";
import TimerIcon from "@material-ui/icons/Timer";
import useMedia from "use-media";
import Paper from "@material-ui/core/Paper";

import {
  selectSelectedMenu,
  editRecord,
  selectEditedRecord,
  selectSelectTargetDay,
  selectLastRecord,
  initialState,
  fetchAsyncCreateTempRecord,
  fetchAsyncUpdateTempRecord,
  fetchAsyncCreateTempOriginalRecord,
  fetchAsyncUpdateTempOriginalRecord,
} from "../home/homeSlice";
import { POST_ORIGINAL_RECORD } from "../../types/types";

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(2, 1),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
    maxWidth: "66.667%",
  },
  paperRes: {
    display: "flex",
    flexDirection: "column",
    position: "fixed",
    width: "100%",
    padding: theme.spacing(2, 1),
    margin: 0,
    boxSizing: "border-box",
    zIndex: 2,
    backgroundColor: "#f1f9ff",
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
    borderRadius: 8,
    backgroundColor: "#fff",
    padding: theme.spacing(2, 2),
    boxSizing: "border-box",
  },

  color: {
    color: "#333333",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#2699FB",
  },
  lastTimeBtn: {
    margin: theme.spacing(3, 0, 2),
    backgroundColor: "#6699cc",
  },

  headerBack: {
    paddingRight: theme.spacing(3),
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: theme.spacing(0, 1),
  },
  record: {
    display: "flex",
    justifyContent: "space-between",
    borderBottom: "1px solid rgba(0, 0, 0, 0.42)",
    marginBottom: 10,
  },
  add: {
    fontSize: 60,
    color: "#2699FB",
  },
  remove: {
    fontSize: 60,
    color: "#ffc184",
    marginRight: 10,
  },
  unit: {
    paddingRight: theme.spacing(1),
  },
  recordItem: {
    width: "50%",
  },
}));

const AddRecord: React.FC = () => {
  const history = useHistory();
  const classes = useStyles();
  const dispatch = useDispatch();
  const selectedMenu = useSelector(selectSelectedMenu);
  const editedRecord = useSelector(selectEditedRecord);
  const targetDay = useSelector(selectSelectTargetDay);
  const lastRecord = useSelector(selectLastRecord);
  const isWide = useMedia({ minWidth: "600px" });

  //回数、セット追加
  const addRecord = () => {
    if (editedRecord.length < 10) {
      dispatch(
        editRecord([
          ...editedRecord,
          {
            id: 0,
            menu_id: selectedMenu.id,
            weight: null,
            number_value: 0,
            set_value: null,
            date: targetDay,
          },
        ])
      );
    }
  };

  //回数、セット削除
  const removeRecord = () => {
    if (editedRecord.length > 1) {
      let newRecord = [...editedRecord];
      newRecord.pop();
      dispatch(editRecord(newRecord));
    }
  };
  //画面遷移
  const backProfile = useCallback(async () => {
    await history.goBack();
    await dispatch(editRecord(initialState.editedRecord));
  }, [history, dispatch]);

  const handleCreateRecord = async (e: React.FormEvent<HTMLFormElement>) => {
    await e.preventDefault();
    //オリジナルメニューの場合
    if (selectedMenu.user_id !== 0) {
      await editedRecord.map(async (record) => {
        const para: POST_ORIGINAL_RECORD = {
          menu_title: selectedMenu.title,
          menu_part_number: selectedMenu.part,
          menu_part: selectedMenu.part_name,
          menu_type_number: selectedMenu.type,
          menu_type: selectedMenu.type_name,
          menu_color_number: selectedMenu.color,
          menu_color: selectedMenu.menu_color,
          menu_user_id: String(selectedMenu.user_id),
          ...record,
        };
        record.id === 0
          ? await dispatch(fetchAsyncCreateTempOriginalRecord(para))
          : await dispatch(fetchAsyncUpdateTempOriginalRecord(para));
      });
    } else {
      await editedRecord.map(async (record) => {
        record.id === 0
          ? await dispatch(fetchAsyncCreateTempRecord(record))
          : await dispatch(fetchAsyncUpdateTempRecord(record));
      });
    }

    await history.push("/home/record/board");
  };

  //入力時に対象のeditedRecordを更新
  const handleInputRecord = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    index: number
  ) => {
    let arra = editedRecord.map((record, rIndex) =>
      rIndex === index
        ? {
            ...record,
            [e.target.name]: e.target.value,
          }
        : record
    );
    dispatch(editRecord(arra));
  };

  const handleReflectLastTimeRecord = useCallback(async () => {
    const data = lastRecord.results.map((record) => ({
      id: 0,
      menu_id: record.menu_id,
      weight: record.weight,
      number_value: record.number_value,
      set_value: record.set_value,
      date: targetDay,
    }));
    await dispatch(editRecord(data));
  }, [dispatch, editedRecord]);

  //新規作成時に、レコードのmenuとdateを格納する
  //既存のレコード編集時には処理しない
  useEffect(() => {
    if (editedRecord.length > 0 && editedRecord[0].id === 0) {
      dispatch(
        editRecord([
          {
            id: 0,
            menu_id: selectedMenu.id,
            weight: null,
            number_value: 0,
            set_value: null,
            date: targetDay,
          },
        ])
      );
    }
  }, [dispatch]);

  return (
    <Grid container>
      <Grid item xs={12} component={Paper} elevation={6} square>
        <div className={isWide ? classes.paper : classes.paperRes}>
          <div className={classes.header}>
            <div className={classes.headerBack}>
              <ArrowBackIcon onClick={backProfile} className={classes.color} />
            </div>
            <div></div>
            <div>
              <RemoveCircleIcon
                className={classes.remove}
                onClick={removeRecord}
              />
              <AddCircleIcon className={classes.add} onClick={addRecord} />
            </div>
          </div>

          <form className={classes.form} onSubmit={handleCreateRecord}>
            <TextField
              margin="normal"
              required
              fullWidth
              id="menuTitle"
              name="menuTitle"
              disabled
              value={selectedMenu?.title}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <AssignmentIcon />
                  </InputAdornment>
                ),
              }}
            />
            {editedRecord.map((record, index) => (
              <div key={index}>
                {Number(selectedMenu?.type) === 2 && (
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="weight"
                    label="重さ(kg)"
                    name="weight"
                    autoFocus
                    type="number"
                    placeholder={
                      lastRecord.count >= 1 && lastRecord.results[0].weight
                        ? lastRecord.results[0].weight
                        : ""
                    }
                    value={record.weight === null ? undefined : record.weight}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <FitnessCenterIcon />
                        </InputAdornment>
                      ),
                      inputProps: { min: 1, max: 400, step: 0.01 },
                      endAdornment: (
                        <InputAdornment position="end" className={classes.unit}>
                          Kg
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => handleInputRecord(e, index)}
                  />
                )}
                {Number(selectedMenu.type) === 3 && (
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="number_value"
                    label="距離"
                    name="number_value"
                    autoFocus
                    type="number"
                    placeholder={
                      lastRecord.count >= 1 &&
                      lastRecord.results[0].number_value
                        ? String(lastRecord.results[0].number_value)
                        : ""
                    }
                    value={
                      record.number_value === 0
                        ? undefined
                        : record.number_value
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <DirectionsRunIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end" className={classes.unit}>
                          Km
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => handleInputRecord(e, index)}
                  />
                )}
                {Number(selectedMenu.type) === 4 && (
                  <TextField
                    margin="normal"
                    required
                    fullWidth
                    id="weight"
                    label="時間"
                    name="number_value"
                    value={
                      record.number_value === 0
                        ? undefined
                        : record.number_value
                    }
                    autoFocus
                    type="number"
                    placeholder={
                      lastRecord.count >= 1 &&
                      lastRecord.results[0].number_value
                        ? String(lastRecord.results[0].number_value)
                        : ""
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <TimerIcon />
                        </InputAdornment>
                      ),
                      endAdornment: (
                        <InputAdornment position="end" className={classes.unit}>
                          Min
                        </InputAdornment>
                      ),
                    }}
                    onChange={(e) => handleInputRecord(e, index)}
                  />
                )}
                {Number(selectedMenu.type) === 3 ||
                  Number(selectedMenu.type) === 4 || (
                    <div className={classes.record}>
                      <TextField
                        className={classes.recordItem}
                        margin="normal"
                        required
                        name="number_value"
                        label="レップ数(回)"
                        id="rep"
                        type="number"
                        placeholder={
                          lastRecord.count >= 1 &&
                          lastRecord.results[0].number_value
                            ? String(lastRecord.results[0].number_value)
                            : ""
                        }
                        value={
                          record.number_value === 0
                            ? undefined
                            : record.number_value
                        }
                        // 自重トレーニングの場合autoFocusを採用
                        autoFocus={Number(selectedMenu.type) === 1 && true}
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <ThreeSixtyIcon />
                            </InputAdornment>
                          ),
                          inputProps: { min: 1, max: 100 },
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              className={classes.unit}
                            >
                              Rep
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => handleInputRecord(e, index)}
                      />
                      <TextField
                        className={classes.recordItem}
                        margin="normal"
                        required
                        name="set_value"
                        label="セット数"
                        type="number"
                        id="set"
                        placeholder={
                          lastRecord.count >= 1 &&
                          lastRecord.results[0].set_value
                            ? String(lastRecord.results[0].set_value)
                            : ""
                        }
                        value={
                          record.set_value === null
                            ? undefined
                            : record.set_value
                        }
                        InputProps={{
                          startAdornment: (
                            <InputAdornment position="start">
                              <RepeatIcon />
                            </InputAdornment>
                          ),
                          inputProps: { min: 1, max: 100 },
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              className={classes.unit}
                            >
                              Set
                            </InputAdornment>
                          ),
                        }}
                        onChange={(e) => handleInputRecord(e, index)}
                      />
                    </div>
                  )}
              </div>
            ))}
            {lastRecord.count !== 0 && (
              <Button
                fullWidth
                variant="contained"
                color="primary"
                className={classes.lastTimeBtn}
                onClick={handleReflectLastTimeRecord}
              >
                前回の入力値を反映
              </Button>
            )}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              登録
            </Button>
          </form>
        </div>
      </Grid>
    </Grid>
  );
};

export default AddRecord;
